var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { MobileEnquiryCTA } from '.';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment MobileEnquiryCTA on Property {\n    agents {\n      phone\n      agency {\n        phone\n      }\n    }\n  }\n"])));
var graphQLToProps = _ref => {
  var _agents$, _agents$2, _agents$2$agency;
  var agents = _ref.agents;
  return {
    phone: ((_agents$ = agents[0]) === null || _agents$ === void 0 ? void 0 : _agents$.phone) || ((_agents$2 = agents[0]) === null || _agents$2 === void 0 ? void 0 : (_agents$2$agency = _agents$2.agency) === null || _agents$2$agency === void 0 ? void 0 : _agents$2$agency.phone)
  };
};
var MobileEnquiryCTAGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(MobileEnquiryCTA, _extends({}, props, graphQLToProps(property)));
};
MobileEnquiryCTAGraphQL.fragment = fragment;
MobileEnquiryCTAGraphQL.propTypes = {
  property: PropTypes.shape({
    agents: PropTypes.arrayOf(PropTypes.shape({
      phone: PropTypes.string
    }))
  }).isRequired
};
export default MobileEnquiryCTAGraphQL;